module.exports = __webpack_public_path__ + "static/media/upload_guide.e98490f3.png";